import constants from 'constants/index'

const { LOADING_MESSAGES, LOADING_MESSAGE_CYCLE_START } = constants.dai.disputes

const getLoadingMessage = (pollCount) => {
  if (pollCount < LOADING_MESSAGES.length) return LOADING_MESSAGES[pollCount]
  const cycleLength = LOADING_MESSAGES.length - LOADING_MESSAGE_CYCLE_START
  return LOADING_MESSAGES[
    LOADING_MESSAGE_CYCLE_START +
      ((pollCount - LOADING_MESSAGE_CYCLE_START) % cycleLength)
  ]
}

export default getLoadingMessage
